module.exports = __webpack_public_path__ + "img/4.0b37e4d1.png";